'use client';

// TODO: 重新確認一下手法

import { CustomEventName, GTMConstants, GTMEventKey } from '@fe-cnyes/fe-common-gtm';
import { errorMsg, successMsg } from '@fe-common-ui/Snackbar';
import { createCookie, getCookie, removeCookie } from '@fe-common-utils/libs/cookie';
import { isClient } from '@fe-common-utils/libs/utils';
import {
  MOBILE_NEWS_DETAIL_LARGE,
  MOBILE_NEWS_DETAIL_NORMAL,
  AI_SUMMARY_FONT_LARGE,
  AI_SUMMARY_FONT_NORMAL,
  AI_SUMMARY_INDEX_FONT_LARGE,
  AI_SUMMARY_INDEX_FONT_NORMAL
} from '@fe-news/constants/size/font';
import { FONT_SIZE_COOKIE } from './type';
import { useFontSizeStore } from '@fe-news/context/font-size-zustand';

const setFontCookie = () => {
  if (getCookie(FONT_SIZE_COOKIE, false)) {
    removeCookie(FONT_SIZE_COOKIE, { path: '/' });
    useFontSizeStore.getState().setFontSize('default');
  } else {
    createCookie({ key: FONT_SIZE_COOKIE, value: `${MOBILE_NEWS_DETAIL_LARGE}px`, options: { path: '/' } });
    useFontSizeStore.getState().setFontSize('large');
  }
};

export const newsUrlWithUtm = (url: string, source: string, medium: string, campaign: string) => {
  return `${url}?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`;
};

export const lineShare = ({ isMobile }: { isMobile: boolean }) => {
  if (isClient) {
    const encodedSharedCurrentUrl = encodeURIComponent(
      newsUrlWithUtm(window?.location?.href ?? '', 'lineshare', 'line', 'news')
    );

    const metaTitle = isMobile ? document.title.split('|')[0] : document.title;

    return `https://line.me/R/msg/text/?${metaTitle}%0A${encodedSharedCurrentUrl}`;
  }

  return '';
};

export const fbShare = () => {
  if (isClient) {
    const encodedSharedCurrentUrl = encodeURIComponent(
      newsUrlWithUtm(window?.location?.href ?? '', 'fbshare', 'facebook', 'news')
    );

    const encodeCurrentUrl = encodeURIComponent(window?.location?.href ?? '');

    return `https://www.facebook.com/dialog/share?app_id=${process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}&display=popup&href=${encodeCurrentUrl}&redirect_uri=${encodedSharedCurrentUrl}`;
  }

  return '';
};

export const newsPrintArticle = () => {
  if (isClient) {
    const currentUrl = window?.location?.href;
    const newsPrint = currentUrl?.replace('/news/id/', '/news/print/');
    return newsPrint;
  }
  return '';
};

export const writeToClickBoard = async () => {
  try {
    await navigator.clipboard.writeText(window?.location?.href);

    successMsg({ title: '連結已複製!' });
  } catch (error) {
    console.error('error:', error);

    errorMsg({ title: '連結無法複製!' });
  }
};

/**
 * 需確定 cookie 裡面是否有儲存fontSizeCookie的值，決定是否要切換成大字或是小字。
 */
const toggleIconUrl = getCookie(FONT_SIZE_COOKIE, false)
  ? '/assets/icons/topBar/icon-font.svg'
  : '/assets/icons/topBar/icon-font-changed.svg';

/**
 * 切換文章字體大小的功能
 */
export const toggleFont = () => {
  // 取得文章容器元素
  const articleNode = document.querySelector('#article-container');
  // 取得所有字體切換按鈕
  const toggleButtons = document?.querySelectorAll('#toggle-font-button') ?? [];
  // 取得文章內所有段落元素
  const sectionContent = articleNode?.querySelectorAll('p') ?? [];
  const h6Content = articleNode?.querySelectorAll('h6') ?? [];
  const summaryTitle = document?.querySelectorAll('.summary-title') ?? [];
  const summaryIndex = document?.querySelectorAll('.summary-index') ?? [];
  const summaryContent = document?.querySelectorAll('.summary-item-content') ?? [];
  // 從 Cookie 中取得目前的字體大小模式
  const isEnableLargeFontMode = getCookie(FONT_SIZE_COOKIE, false);
  // 根據目前模式決定要切換的字體大小
  const fontSize = isEnableLargeFontMode ? `${MOBILE_NEWS_DETAIL_NORMAL}px` : `${MOBILE_NEWS_DETAIL_LARGE}px`;
  const summaryFontSize = isEnableLargeFontMode ? `${AI_SUMMARY_FONT_NORMAL}px` : `${AI_SUMMARY_FONT_LARGE}px`;
  const summaryIndexFontSize = isEnableLargeFontMode
    ? `${AI_SUMMARY_INDEX_FONT_NORMAL}px`
    : `${AI_SUMMARY_INDEX_FONT_LARGE}px`;
  // 根據目前模式決定要切換的行高
  const lineHeight = isEnableLargeFontMode ? '1.7' : '1.75';

  // 遍歷所有段落元素，設定新的字體大小和行高
  for (const pElement of sectionContent) {
    pElement.style.fontSize = fontSize;
    pElement.style.lineHeight = lineHeight;
  }
  for (const h6Element of h6Content) {
    h6Element.style.fontSize = fontSize;
    h6Element.style.lineHeight = lineHeight;
  }
  for (const titleElement of summaryTitle) {
    (titleElement as HTMLElement).style.fontSize = summaryFontSize;
  }
  for (const indexElement of summaryIndex) {
    (indexElement as HTMLElement).style.fontSize = summaryIndexFontSize;
  }
  for (const summaryElement of summaryContent) {
    (summaryElement as HTMLElement).style.fontSize = summaryFontSize;
  }

  // 遍歷所有字體切換按鈕，更新按鈕圖示
  for (const buttonElement of toggleButtons) {
    (buttonElement as HTMLImageElement).src = getCookie(FONT_SIZE_COOKIE, false)
      ? '/assets/icons/topBar/icon-font-changed.svg' // 大字體模式的圖示
      : '/assets/icons/topBar/icon-font.svg'; // 一般字體模式的圖示
  }

  // 更新 Cookie 中的字體大小設定
  setFontCookie();
};

export function sharingTabsGenerator(isMobile: boolean) {
  return [
    {
      icon: '/assets/icons/topBar/icon-facebookbtn.svg',
      url: fbShare(),
      gtmEvent: {
        [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
        [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
        [GTMEventKey.CLICK_ITEM]: 'Facebook'
      }
    },
    {
      icon: '/assets/icons/topBar/icon-linebtn.svg',
      url: lineShare({ isMobile }),
      gtmEvent: {
        [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
        [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
        [GTMEventKey.CLICK_ITEM]: 'Line'
      }
    },
    {
      icon: '/assets/icons/topBar/icon-linkbtn.svg',
      isButton: true,
      onAction: writeToClickBoard,
      gtmEvent: {
        [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
        [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
        [GTMEventKey.CLICK_ITEM]: 'Copy_Link'
      }
    }
  ];
}

export const SELECT_TABS = [
  ...sharingTabsGenerator(true),
  {
    icon: toggleIconUrl,
    url: '',
    id: 'toggle-font-button',
    isButton: true,
    onAction: toggleFont,
    imageStyle: { width: 24, height: 24 },
    gtmEvent: {
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
      [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
      [GTMEventKey.CLICK_ITEM]: 'Adjust_Size'
    }
  }
  // 第二階換上線
  // {
  //   icon: '/assets/icons/topBar/icon-morebtn.svg',
  //   url: '',
  //   isButton: true,
  //   onAction: () => {},
  // },
];

export const SELECT_DESKTOP_TABS = [
  ...sharingTabsGenerator(false),
  {
    icon: '',
    title: '其他'
  },
  {
    icon: toggleIconUrl,
    url: '',
    isButton: true,
    onAction: toggleFont,
    id: 'toggle-font-button',
    wrapperStyle: {
      width: 36,
      height: 36,
      border: '1px solid #e2e8f1',
      backgroundColor: 'white',
      borderRadius: 18
    },
    imageStyle: { width: 24, height: 24 },
    gtmEvent: {
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
      [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
      [GTMEventKey.CLICK_ITEM]: 'Adjust_Size'
    }
  },
  {
    icon: '/assets/icons/topBar/icon-printbtn.svg',
    url: newsPrintArticle(),
    gtmEvent: {
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
      [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
      [GTMEventKey.CLICK_ITEM]: 'Print'
    }
  }
  // {
  //   icon: '/assets/icons/topBar/icon-collect.svg',
  //   url: '',
  //   isButton: true
  // }
];
